/**
 *
 * Sticky Header, checks position of header next element and if scrolls out of screen adds a class to header.
 * A Next element is required in the DOM otherwise cannot be detached
 */

var els = [];

module.exports = {

  init: function (className, window) {
    $('.' + className).each(function () {
      var next = $(this).nextAll('div')[0];
      if (next) {
        // See init scroll position on page
        var doc = document.documentElement;
        var topPosition = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        if(topPosition >= $(this).outerHeight(true) && !$(this).hasClass('mywort-header--fixed')){
          $(this).addClass("mywort-header--fixed");
          $('<div id="mywort-header-duply" style="height:' + $(this).outerHeight(true) + 'px"></div>').insertBefore($(this));
        }
        els.push({that: this, next: next});
      }
    });
    window.addEventListener('scroll', this.scrollHandler);

    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if(isTouchDevice){
      window.addEventListener('touchmove', this.scrollHandler);
    }

  },

  scrollHandler: function(){
    for (var i = 0; i < els.length; i++) {
      var obj = els[i];
      var next = obj.next;
      var $el = $(obj.that);
      var nextTop = $el.offset().top;
      if (next) {
        nextTop = next.getBoundingClientRect().top
      }
      if (nextTop - $el.outerHeight(true) <= 0) {
        if (!$el.hasClass('mywort-header--fixed')) {
          $el.addClass("mywort-header--fixed");
          $('<div id="mywort-header-duply" style="height:' + $el.outerHeight(true) + 'px"></div>').insertBefore($el);
          $('.mywort-static-h1').each(function() {
              $(this).addClass('hide');
          })
        }
      } else {
        $('#mywort-header-duply').remove();
        if ($el.hasClass('mywort-header--fixed')) {
          $el.removeClass('mywort-header--fixed');
        }
        $('.mywort-static-h1').each(function() {
          $(this).removeClass('hide');
        })
      }
    }
  }
};



// WEBPACK FOOTER //
// ./js/mywort/styleguide/sticky-header.js